// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"socialMedia-module--wrapper--1ON1N","icon":"socialMedia-module--icon--1NLaX"};